export default __webpack_public_path__ + "static/media/xiaoshoue.43133a28.png";